import { CodeOutlined, ModelLLM, RobotOutlined, ToolOutlined } from "@/icons"
import { WorkflowIcon } from "@/pages/AiDiscovery/components/molecules/WorkflowTypeCell/WorkflowTypeIcons"
import { TABS } from "./helpers"

// A workflow's components are its steps, as its agents, tools and model calls,
// and its code steps; an agent's are its agents, tools and models, in the AI
// discovery tabs' order
export const COMPONENT_TABS = {
  agent: [
    { label: "Agents", value: TABS.agents, icon: <RobotOutlined /> },
    { label: "Tools", value: TABS.tools, icon: <ToolOutlined /> },
    { label: "Models", value: TABS.models, icon: <ModelLLM /> }
  ],
  workflow: [
    { label: "Agents", value: TABS.agents, icon: <RobotOutlined /> },
    { label: "Workflows", value: TABS.workflows, icon: <WorkflowIcon /> },
    { label: "Tools", value: TABS.tools, icon: <ToolOutlined /> },
    { label: "Model calls", value: TABS.modelCalls, icon: <ModelLLM /> },
    { label: "Code steps", value: TABS.codeSteps, icon: <CodeOutlined /> }
  ]
}

// The segment a tab opens on: an agent's tools, a workflow's agents
export const DEFAULT_COMPONENT_TAB = {
  agent: TABS.tools,
  workflow: TABS.agents
}
